import BlogIndex from "components/commons/BlogIndex";

const BlogLayout = ({ children, indexTitle, indexes = [], withIndex = false }) => {
  return (
    <div className="container-wrapper row-mobile-col gap-8">
      {
        withIndex && (
          <BlogIndex
            title={indexTitle}
            list={indexes}
          />
        )
      }

      {children}
    </div>
  );
};

export default BlogLayout;
